import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { BriefAssignmentState } from "@sol/sdk";
import { GraduationCap02 } from "@sol/uikit/core/icons/Education/GraduationCap02";
import { FileEdit02 } from "@sol/uikit/core/icons/Files/FileEdit02";
import { FileUp02 } from "@sol/uikit/core/icons/Files/FileUp02";
import { FileX02 } from "@sol/uikit/core/icons/Files/FileX02";
import { FolderDown01 } from "@sol/uikit/core/icons/Files/FolderDown01";
import { Tooltip } from "@sol/uikit/data-display/Tooltip/Tooltip";

interface BriefStatusBadgeProps {
    status?: BriefAssignmentState;
    showTooltip?: boolean;
}

const { ASSIGNED, RENDERED, CORRECTED, VALIDATED } = BriefAssignmentState;

export const STATUS_CONFIG: Record<
    BriefAssignmentState,
    {
        label: BriefAssignmentState;
        icon: ReactNode;
    }
> = {
    [ASSIGNED]: {
        label: ASSIGNED,
        icon: <FileUp02 size={20} className="text-ant-orange" />,
    },
    [RENDERED]: {
        label: RENDERED,
        icon: <FolderDown01 size={20} className="text-ant-yellow" />,
    },
    [CORRECTED]: {
        label: CORRECTED,
        icon: <FileEdit02 size={20} className="text-ant-blue" />,
    },
    [VALIDATED]: {
        label: VALIDATED,
        icon: <GraduationCap02 size={20} className="text-color-ant-success" />,
    },
};

export function getStatusConfig(status?: BriefAssignmentState) {
    if (status && STATUS_CONFIG[status]) {
        return STATUS_CONFIG[status];
    }

    return {
        label: "unassigned" as BriefAssignmentState,
        icon: <FileX02 size={20} className="text-color-ant-quaternary" />,
    };
}

export const BriefStatusBadge = ({ status, showTooltip = true }: BriefStatusBadgeProps) => {
    const [t] = useTranslation(undefined, { keyPrefix: "features.dashboards.details.briefsProgress.status" });

    const config = getStatusConfig(status);

    return (
        <Tooltip title={showTooltip ? t(config.label) : undefined}>
            <span className="sr-only">{t(config.label)}</span>
            {config.icon}
        </Tooltip>
    );
};
